
import { createStore, applyMiddleware, compose  } from 'redux'
import thunk from 'redux-thunk'
import promise from 'redux-promise-middleware'
import devTools from 'remote-redux-devtools';

import combinedReducer from './reducer'

const enhancer = compose(
	applyMiddleware(promise(), thunk),
	// devTools({
 //      name: 'HomeServe', realtime: true,
 //    }),
)


export default createStore(combinedReducer, enhancer)


// WEBPACK FOOTER //
// ./src/store.js